<template lang="pug">
component.slide(v-if="image", :is="tag", v-bind="props")
    figure
        img(
            v-lazy="image",
            rel="noopener"
        )
</template>

<script>
import { get, trim } from '@/helpers';

export default {
    name: 'Slide',
    data() {
        return {
            delay: 0,
            mouseover: false
        };
    },
    props: {
        slide: {
            type: Object,
            required: true
        },
        maxWidth: {
            type: Number,
            required: true
        },
        maxHeight: {
            type: Number,
            required: true
        }
        // imageLoaded: {
        //     type: Boolean,
        //     default: false,
        // }
    },
    computed: {
        tag() {
            let tag = 'div';
            if (this.path) tag = 'router-link';
            else if (this.href) tag = 'a';
            return tag;
        },
        props() {
            let props = {};

            switch (this.tag) {
                case 'a':
                    props.href = this.href;
                    props.target = this.target;
                    break;

                case 'router-link':
                    props.to = this.path;
                    break;
            }

            return props;
        },
        image() {
            const image = get(this.slide, 'images.0');
            if (!image) return false;

            if (!this.maxWidth || !this.maxHeight) return false;

            let fit = get(image, 'pivot.fit') || 'fit=crop&crop=focalpoint&x=.5&y=.5&z=1';
            const parameters = {
                ...get(fit.match(/x=(?<fx>[0-1]?\.?[0-9]*)/), 'groups'),
                ...get(fit.match(/y=(?<fy>[0-1]?\.?[0-9]*)/), 'groups'),
                ...get(fit.match(/z=(?<fz>[1-9]+\.?[0-9]*)/), 'groups'),
                ...get(fit.match(/w=(?<w>[0-9]+\.?[0-9]*)/), 'groups'),
                ...get(fit.match(/h=(?<h>[0-9]+\.?[0-9]*)/), 'groups')
            };
            // let { w, h, fx, fy, fz } = parameters;
            let { fx, fy, fz } = parameters;

            let width, height, aspectRatio;
            aspectRatio = 5 / 3;

            if (!fx) fx = 0.5;
            if (!fy) fy = 0.5;
            if (!fz) fz = 1;

            // fit: cover

            width = this.maxWidth;
            height = width / aspectRatio;
            // aspectRatio = width / height;

            fit = `crop=focalpoint&x=${fx}&y=${fy}&z=${fz}&w=${width}&h=${height}`;

            // TODO:
            // fit: contain

            const storageRoute = trim(
                `${process.env.VUE_APP_API_HTTP}${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE}`,
                '/'
            );

            return {
                src: `${storageRoute}/images/${image.id}/${image.name}?${fit}`,
                error: `${storageRoute}/images/${image.id}/${image.name}?${fit}&preview=greyscale`,
                loading: `${storageRoute}/images/${image.id}/${image.name}?${fit}&preview=blur`,
                width,
                height,
                aspectRatio
            };
        },
        width() {
            if (this.image.width) return Math.min(this.maxWidth, this.image.width);
            else return undefined;
        },
        height() {
            if (this.width && this.image.aspectRatio) return this.width / this.image.aspectRatio;
            else return undefined;
        },
        hyperlink() {
            return get(this.slide, 'hyperlink') || {};
        },
        href() {
            let href = false;

            if (this.hyperlink.type !== 'internal' && get(this.hyperlink, 'href')) {
                const link = this.hyperlink.href;
                switch (this.hyperlink.type) {
                    case 'external':
                        if (!link.startsWith('https://') && !link.startsWith('http://')) href = `https://${link}`;
                        else href = link;
                        break;

                    case 'mailto':
                        href = `mailto:${link}`;
                        break;

                    case 'tel':
                        href = `tel:${link}`;
                        break;
                }
            }

            return href;
        },
        target() {
            return get(this.hyperlink, 'target') || '_self';
        },
        path() {
            if (this.hyperlink.type === 'internal' && get(this.hyperlink, 'menuItem.path'))
                return this.hyperlink.menuItem.path;
            else return false;
        },
        linkText() {
            return get(this.hyperlink, 'name') || 'mehr...';
        },
        style() {
            let style = {};

            if (this.slide.color) {
                style.background = this.slide.color;
            }

            return style;
        }
    }
};
</script>

<style lang="sass" scoped>
figure
img
    object-fit: contain

    margin: 0 auto
    @media (min-width: 1450px)
        max-width: 1450px
        max-width: 1450px
</style>
